import {
  SET_USER_COMPONENT_GROUPS,
  SET_COMPONENT_GROUP_COMPONENTS,
  SET_ACTIVE_USER_COMPONENT_GROUPS,
  ADD_USER_COMPONENT_GROUP,
  SET_SAVE_USER_COMPONENT_GROUP_FAILED,
  SET_SAVE_USER_COMPONENT_GROUP_FAILED_RESET,
  SET_DELETE_USER_COMPONENT_GROUP_SUCCESS,
  SET_DELETE_USER_COMPONENT_GROUP_SUCCESS_RESET
} from "redux/constants/flowDesigner";

const initialState = {
  userComponentGroups: [],
  activeUserComponentGroups: [],
  componentGroupComponents: [],
  saveUserComponentGroupFailed: false,
  deleteUserComponentGroupSuccess: false
};

const componentGroups = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USER_COMPONENT_GROUPS:
      return {
        ...state,
        userComponentGroups: payload
      };
    case SET_COMPONENT_GROUP_COMPONENTS:
      return {
        ...state,
        componentGroupComponents: payload
      };
    case SET_ACTIVE_USER_COMPONENT_GROUPS:
      return {
        ...state,
        activeUserComponentGroups: payload
      };
    case ADD_USER_COMPONENT_GROUP:
      return {
        ...state,
        userComponentGroups: [...state.userComponentGroups, payload]
      };
    case SET_SAVE_USER_COMPONENT_GROUP_FAILED:
      return {
        ...state,
        saveUserComponentGroupFailed: true
      };
    case SET_SAVE_USER_COMPONENT_GROUP_FAILED_RESET:
      return {
        ...state,
        saveUserComponentGroupFailed: false
      };
    case SET_DELETE_USER_COMPONENT_GROUP_SUCCESS:
      return {
        ...state,
        deleteUserComponentGroupSuccess: true
      };
    case SET_DELETE_USER_COMPONENT_GROUP_SUCCESS_RESET:
      return {
        ...state,
        deleteUserComponentGroupSuccess: false
      };
  }

  return state;
};

export default componentGroups;
